module.exports = __webpack_public_path__ + "fonts/free-fa-solid-900.4cfa813.ttf";